<template>
  <kd-navigation
    :class="[{ 'is-web': isWeb }]"
    :defaultActiveIndex="defaultIndex"
    :dropdownValue="navigationSelected"
    @change="changeItemFn"
  >
    <kd-navigation-item
      v-for="(item, index) in navigationTab"
      :index="index"
      :key="item + index"
      @click="clickItemFn(index)"
    >
      {{ item }}
    </kd-navigation-item>
  </kd-navigation>
</template>

<script>
import { isEnvMobile } from '@/common/utils';
export default {
  name: 'kd-tab-component',
  data() {
    return {
      navigationSelected: '',
      isWeb: false,
    };
  },
  props: {
    navigationTab: {
      type: Array,
      default: [],
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    changeItemFn(index) {
      this.navigationSelected = index;
      this.$emit('selected', this.navigationSelected);
    },
    clickItemFn() {},
  },
  created() {
    this.isWeb = isEnvMobile();
  },
};
</script>

<style lang="scss" scoped>
.kdv-navigation {
  flex-direction: column;
  margin: 24px auto 0 auto;
  &.is-web {
    margin-top: px2rem(24);
    :deep(.kdv-navigation-item) {
      margin: 0 px2rem(14);
      .kdv-navigation-item--text {
        margin-left: 0;
        margin-right: 0;
      }
      .kdv-navigation-item__txt {
        padding: 0 px2rem(32);
        height: px2rem(64);
        line-height: px2rem(62) !important;
        font-size: px2rem(28);
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
        border: 1px solid var(--kd-color-line-light, rgb(13 13 13 / 6%));
        text-align: center;
        background: #fff;
        border-radius: px2rem(999);
        font-weight: normal;
      }
    }
  }
  .kdv-navigation-item {
    margin: 0 7px;
    :deep(.kdv-navigation-item--text) {
      margin-right: 0;
    }
    :deep(.kdv-navigation-item__txt) {
      padding: 0 16px;
      height: 33px;
      line-height: 31px !important;
      font-size: var(--kd-font-size-base, 14px);
      color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      border: 1px solid var(--kd-color-line-light, rgb(13 13 13 / 6%));
      text-align: center;
      background: #fff;
      border-radius: 999px;
      font-weight: normal;
    }
    &.is-active {
      :deep(.kdv-navigation-item__txt) {
        background: rgba(0, 0, 0, 1);
        margin-left: 0;
        font-weight: 600;
        color: #fff;
      }
    }
  }
  
  :deep(.kdv-navigation-item__func),
  :deep(.kdv-navigation__more) {
    display: none;
  }
}
</style>
